<div class="card step-card flex flex-column">
  <div>
    <form [formGroup]="integrationModulesForm" *ngIf="integrationModulesForm">
      <div class="mb-3 flex flex-column sm:flex-row justify-content-end">
        <button
          [label]="'new.module' | transloco"
          (click)="addModule()"
          pButton
          pRipple
          icon="pi pi-plus"
          iconPos="left"
          [disabled]="!('ROLE_ADMIN' | userHasRole)"
        ></button>
      </div>
      <div *ngIf="rowsForm.controls.length > 0" class="my-5" formArrayName="integrationModules">
        <div class="grid">
          <div class="col-12" *ngFor="let control of rowsForm.controls; let index=index" [formGroupName]="index">
            <div class="module-card grid">
              <div class="col-12 flex justify-content-end">
                <button
                  (click)="onRowDelete(index)"
                  pButton
                  pRipple
                  class="p-button-rounded p-button-danger p-button-text"
                  type="button"
                  icon="pi pi-times"
                  *ngIf="('ROLE_ADMIN' | userHasRole)"
                ></button>
              </div>
              <div class="col-12 lg:col-6">
                <div class="form-field col-12">
                  <label>{{'attribute.integrationCode' | transloco}} (*)</label><br>
                </div>
                <div class="col-12">
                  <input pInputText type="text" formControlName="integrationCode" class="w-full" [readonly]="!('ROLE_ADMIN' | userHasRole)" [ngClass]="!('ROLE_ADMIN' | userHasRole) ? 'p-disabled' : ''">
                </div>
                <app-validation-errors [control]="control.get('integrationCode')"></app-validation-errors>
              </div>
              <div class="col-12 lg:col-6">
                <div class="form-field col-12">
                  <label>{{'attribute.integrationIdentifier' | transloco}} (*)</label><br>
                </div>
                <div class="col-12">
                  <input pInputText type="text" formControlName="integrationIdentifier" class="w-full" [readonly]="!('ROLE_ADMIN' | userHasRole)" [ngClass]="!('ROLE_ADMIN' | userHasRole) ? 'p-disabled' : ''">
                </div>
                <app-validation-errors [control]="control.get('integrationIdentifier')"></app-validation-errors>
              </div>
              <div class="col-12 lg:col-6">
                <div class="form-field col-12">
                  <label>{{'model.decoder' | transloco}}</label><br>
                </div>
                <div class="col-12">
                  <p-dropdown
                    [placeholder]="'empty.decoder' | transloco"
                    [options]="getDecoders(index)"
                    [showClear]="!isDefaultDecoder(index)"
                    [disabled]="isDefaultDecoder(index) || !('ROLE_ADMIN' | userHasRole)"
                    styleClass="dropdown-width-md"
                    formControlName="decoder"
                    optionLabel="name"
                    dataKey="name"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 lg:col-6">
                <div class="form-field col-12">
                  <label>{{'model.encoder' | transloco}}</label><br>
                </div>
                <div class="col-12">
                  <p-dropdown
                    [placeholder]="'empty.encoder' | transloco"
                    [options]="getEncoders(index)"
                    [showClear]="true"
                    [disabled]="isDefaultEncoder(index) || !('ROLE_ADMIN' | userHasRole)"
                    styleClass="dropdown-width-md"
                    formControlName="encoder"
                    optionLabel="name"
                    dataKey="uuid"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12">
                <div class="form-field col-12 pb-0 flex align-items-center">
                  <label class="cursor-pointer" (click)="jsonEditor['visible'] = !jsonEditor['visible']">
                    {{'attribute.technicalDetails' | transloco}}
                  </label>
                  <button
                    (click)="jsonEditor['visible'] = !jsonEditor['visible']"
                    [icon]="'pi ' + (jsonEditor['visible'] ? 'pi-chevron-up' : 'pi-chevron-down')"
                    class="p-button-sm p-button-secondary p-button-text" type="button"
                    pButton
                    pRipple
                  ></button>
                </div>
                <div class="col-12 p-3">
                  <json-editor
                    [hidden]="!jsonEditor['visible']"
                    [options]="(('ROLE_ADMIN' | userHasRole) ? jsonEditorService.buildFormEditorOptions() : jsonEditorService.buildReadonlyEditorOptions())"
                    formControlName="technicalDetails"
                    #jsonEditor
                  ></json-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="rowsForm.controls.length === 0" class="font-italic text-center mt-7">
        {{'empty.integrationModules' | transloco}}
      </div>
    </form>
  </div>
  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="onNextStep()"
          [disabled]="!integrationModulesForm?.valid"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
